import React from 'react';
import { Field } from 'redux-form';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';

import { TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';

import * as validator from 'helpers/Validator';
import Header from 'components/shared/Header';

export const FormComponent = ({ name, index, formProps }) => {
  return (
    <div key={index}>
      <div className="row" style={{ marginTop: '10px' }}>
        <Header name="ESCALATION RULE DETAILS" />
        <div className="row" style={{ padding: '20px 0 30px' }}>
          <div className="col-sm-6">
            <Field
              name={`${name}.name`}
              type="text"
              component={TextField}
              validate={validator.required}
              floatingLabelText="Escalation Rule Name"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
              }}
              fullWidth
            />
          </div>
          <div className="col-sm-6">
            <Field
              name={`${name}.escalation_time`}
              component={SelectField}
              style={{ marginTop: '-15px', fontSize: '14px' }}
              floatingLabelText="When should they be notified?"
              fullWidth
              validate={validator.required}
              iconStyle={{ marginLeft: '20px !important' }}
            >
              {renderEscalations}
            </Field>
          </div>
        </div>

        <Header name="ESCALATION RULE MEMBERS" />
        <div className="col-xs-12">
          <div className="row" style={{ padding: '20px 0 0' }}>
            <h5>Who should be notified?</h5>
          </div>
          <Field
            name={`${name}.agents`}
            component={MultiSelectExtended}
            multiple
            hintText="Escalate To"
            data={formProps.agents}
            style={{ fontSize: '14px', marginTop: '5px' }}
            fullWidth
            validate={validator.required}
          />
        </div>
      </div>
    </div>
  );
};

const renderHourSelections = Array.from(Array(12).keys()).map(hour => {
  if (hour === 0) return null;

  return (
    <MenuItem
      key={hour + 1}
      value={parseFloat(((hour + 1) / 24).toFixed(3))}
      primaryText={`${hour + 1} hour(s) after creation`}
    />
  );
});

const renderThirtyDayMenuSelections = Array.from(Array(30).keys()).map(day => {
  return (
    <MenuItem key={day + 1} value={day + 1} primaryText={`${day + 1} day(s) after creation`} />
  );
});

const renderEscalations = renderHourSelections.concat(renderThirtyDayMenuSelections);
